import { render, staticRenderFns } from "./pushBtn.vue?vue&type=template&id=4add8ee6&scoped=true"
import script from "./pushBtn.vue?vue&type=script&lang=js"
export * from "./pushBtn.vue?vue&type=script&lang=js"
import style0 from "./pushBtn.vue?vue&type=style&index=0&id=4add8ee6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add8ee6",
  null
  
)

export default component.exports